import React from 'react';
import { Link } from 'react-router-dom';
import logoLight from "../asset/images/logo_light.png";
import logoDark from "../asset/images/logo_dark.png";
import { LuMail, LuPhone, LuMapPin } from 'react-icons/lu';
import { FaLinkedin, FaGithub, FaTwitter,FaInstagram  } from 'react-icons/fa';

import { useTranslation } from 'react-i18next';
import { useTheme } from './ThemeProvider';

const Footer = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  const servicesLinks = [
    { label: "Mobile Dev", url: "/services" },
    { label: "Web Dev", url: "/services" },
    { label: "ERP Customization", url: "/services" },
    { label: "SAP Services", url: "/services" },
    { label: "Emerging Tech", url: "/services" },
  ];

  const quickLinks = [
    { label: "Home", url: "/" },
    { label: "Services", url: "/services" },
    { label: "About Us", url: "/about" },
    { label: "Our Work", url: "/ourwork" },
    { label: "Contact Us", url: "/contactus" },
  ];

  return (
    <footer className="bg-slate-50 dark:bg-[#0b0b0d] border-t border-slate-200/60 dark:border-neutral-900/60 transition-colors duration-500 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-12 pb-12 border-b border-slate-200/50 dark:border-neutral-800/40">
        
        {/* Col 1: Bio */}
        <div className="lg:col-span-4 flex flex-col gap-5">
          <img
            src={theme === 'dark' ? logoLight : logoDark}
            alt="Softkel Logo"
            className="h-10 md:h-12 w-auto object-contain mr-auto"
          />
          <p className="text-xs text-slate-500 dark:text-neutral-400 leading-relaxed max-w-sm">
            {t('softkelDescription')}
          </p>
          <div className="flex items-center gap-4 text-slate-400">
            <a href="https://www.linkedin.com/company/softkel/" target="_blank" rel="noreferrer" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
              <FaLinkedin className="w-5 h-5" />
            </a>
            <a href="https://www.instagram.com/softkel_/" target="_blank" rel="noreferrer" className="hover:text-slate-900 dark:hover:text-white transition-colors">
              <FaInstagram className="w-5 h-5" />
            </a>
            {/* <a href="https://twitter.com" target="_blank" rel="noreferrer" className="hover:text-blue-400 dark:hover:text-blue-300 transition-colors">
              <FaTwitter className="w-5 h-5" />
            </a> */}
          </div>
        </div>

        {/* Col 2: Quick Links */}
        <div className="lg:col-span-2 flex flex-col gap-4">
          <h4 className="text-xs font-black uppercase text-slate-900 dark:text-white tracking-widest">
            {t('footer_quick_links', 'Quick Links')}
          </h4>
          <ul className="flex flex-col gap-2.5 text-xs text-slate-500 dark:text-neutral-400">
            {quickLinks.map((link, idx) => (
              <li key={idx}>
                <Link to={link.url} className="hover:text-blue-600 dark:hover:text-purple-400 transition-colors font-medium">
                  {t(`nav_${link.label.toLowerCase().replace(/ /g, '_')}`, link.label)}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Col 3: Services */}
        <div className="lg:col-span-2 flex flex-col gap-4">
          <h4 className="text-xs font-black uppercase text-slate-900 dark:text-white tracking-widest">
            {t('footer_services', 'Services')}
          </h4>
          <ul className="flex flex-col gap-2.5 text-xs text-slate-500 dark:text-neutral-400 font-medium">
            {servicesLinks.map((link, idx) => (
              <li key={idx}>
                <Link to={link.url} className="hover:text-blue-600 dark:hover:text-purple-400 transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Col 4: Contact Info */}
        <div className="lg:col-span-4 flex flex-col gap-4">
          <h4 className="text-xs font-black uppercase text-slate-900 dark:text-white tracking-widest">
            {t('footer_contact_info', 'Contact Info')}
          </h4>
          <p className="text-xs text-slate-500 dark:text-neutral-400 leading-normal">
            {t('contactUs')}
          </p>
          <div className="flex flex-col gap-3 text-xs text-slate-600 dark:text-slate-400 mt-2 font-medium">
            <div className="flex items-center gap-3">
              <LuMail className="w-4 h-4 text-blue-600 dark:text-purple-400" />
              <span>info@softkel.com</span>
            </div>
            <div className="flex items-center gap-3">
              <LuPhone className="w-4 h-4 text-blue-600 dark:text-purple-400" />
              <span>+358 41 7298399</span>
            </div>
            <div className="flex items-center gap-3">
              <LuMapPin className="w-4 h-4 text-blue-600 dark:text-purple-400" />
              <span>Helsinki, Finland</span>
            </div>
          </div>
        </div>

      </div>

      {/* Copyright */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-[10px] text-slate-400 dark:text-neutral-500 font-bold uppercase tracking-wider">
        <span>© {new Date().getFullYear()} Softkel. All rights reserved.</span>
        <div className="flex items-center gap-4">
          <button onClick={(e) => e.preventDefault()} className="hover:text-slate-900 dark:hover:text-white transition-colors focus-visible:ring-2 focus-visible:ring-blue-500/50 dark:focus-visible:ring-purple-500/50 outline-none rounded-md px-1.5 py-0.5">Privacy Policy</button>
          <span>•</span>
          <button onClick={(e) => e.preventDefault()} className="hover:text-slate-900 dark:hover:text-white transition-colors focus-visible:ring-2 focus-visible:ring-blue-500/50 dark:focus-visible:ring-purple-500/50 outline-none rounded-md px-1.5 py-0.5">Terms of Service</button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
export { Footer };